import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=8e1b13d2&"
import script from "./statistics.vue?vue&type=script&lang=ts&"
export * from "./statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports